import { render, staticRenderFns } from "./TrainingsReportAdvisor.vue?vue&type=template&id=876ae2dc&scoped=true"
import script from "./TrainingsReportAdvisor.vue?vue&type=script&lang=js"
export * from "./TrainingsReportAdvisor.vue?vue&type=script&lang=js"
import style0 from "./TrainingsReportAdvisor.vue?vue&type=style&index=0&id=876ae2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ae2dc",
  null
  
)

export default component.exports